import { collection, getDocs, query, orderBy, where } from 'firebase/firestore';
import { db } from '../lib/firebase';
import { TeamRanking } from '../types';

export const rankingService = {
  async getRankings(): Promise<TeamRanking[]> {
    const rankingsRef = collection(db, 'rankings');
    const q = query(rankingsRef, orderBy('rank', 'asc'));
    const snapshot = await getDocs(q);
    
    return snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    })) as TeamRanking[];
  },

  getTeamLogo: async (teamName: string): Promise<string | null> => {
    try {
      const rankingsRef = collection(db, 'rankings');
      const q = query(rankingsRef, where('club', '==', teamName));
      const snapshot = await getDocs(q);
      if (!snapshot.empty) {
        const logo = snapshot.docs[0].data().logo;
        if (logo) {
          return logo;
        }
      }
      // Si no se encuentra, intentar con variaciones del nombre
      const variations = [
        teamName.replace('FC ', ''),
        teamName.replace(' UANL', ''),
        teamName.replace(' UNAM', ''),
        `FC ${teamName}`,
      ];
      
      for (const variation of variations) {
        if (variation !== teamName) {
          const qVariation = query(rankingsRef, where('club', '==', variation));
          const snapshotVariation = await getDocs(qVariation);
          if (!snapshotVariation.empty) {
            const logo = snapshotVariation.docs[0].data().logo;
            if (logo) {
              return logo;
            }
          }
        }
      }
      
      return null;
    } catch (error) {
      return null;
    }
  }
}; 